export const baseURL='https://api.themoviedb.org/3';
export const API_KEY = 'd98ba7a3e2f7509d3cd7a6b1496151d8';
export const imageUrl = 'https://image.tmdb.org/t/p/original';